import { Card, Grid, styled } from '@grupoboticario/flora-react';

const styles = {
  Card: styled(Card, {
    padding: '$4',
    borderColor: '$nonInteractivePredominant',
  }),

  CardAlertStandard: styled(Card, {
    borderColor: '$alert-standard',
    boxShadow: 'inset 0 0 0 1px var(--flora--colors-alert-standard)',
  }),

  Grid: styled(Grid, {
    alignItems: 'center',
  }),
};

export default styles;
